import type { StorefrontSummary } from '@tailorcast/shared-types';

interface StorefrontSummaryCardProps {
  data: StorefrontSummary;
}

export function StorefrontSummaryCard({ data }: StorefrontSummaryCardProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <div className="card p-4 text-center">
        <div className="text-2xl font-bold text-gray-900">{data.totalProducts}</div>
        <div className="text-xs text-gray-500 mt-1">Total Products</div>
      </div>
      <div className="card p-4 text-center">
        <div className="text-2xl font-bold text-tailorcast-primary">
          {data.avgOverallScore.toFixed(1)}
        </div>
        <div className="text-xs text-gray-500 mt-1">Avg Score</div>
      </div>
      {Object.entries(data.scoreDistribution).map(([range, count]) => (
        <div key={range} className="card p-4 text-center">
          <div className="text-2xl font-bold text-gray-900">{count}</div>
          <div className="text-xs text-gray-500 mt-1">Score {range}</div>
        </div>
      ))}
    </div>
  );
}
